import { sendErrorToast, sendSuccessToast } from '@/utils/utils'
import http from '@/http'
import Vue from 'vue'

const getErrorMessage = '\uD83D\uDEA8 Erreur lors du chargement de la saisie, veuillez réessayer'
const sendErrorMessage = "\uD83D\uDEA8 Erreur lors de l'envoi de la saisie, veuillez réessayer"
const successMessage = '\uD83C\uDF89 Saisie envoyée avec succès'

class IndicatorsService {
  constructor() {
    this.httpClient = http
  }

  async getReliabilityIndicators({ site, sector, startDate }) {
    const token = await Vue.prototype.$user.getIdToken()
    return this.httpClient
      .get(`/indicators/reliability/sites/${site.sid}/sectors/${sector.sid}?startDate=${startDate}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        return {
          transit: res.data.transit,
          stock: res.data.stock
        }
      })
      .catch(e => {
        console.error('Get Reliability Error', e)
        sendErrorToast(getErrorMessage)
      })
  }

  async setReliabilityIndicators({ site, sector, startDate, indicators }) {
    indicators.userCode = Vue.prototype.$userInfos && Vue.prototype.$userInfos.employeeNumber ? Vue.prototype.$userInfos.employeeNumber : ''
    const token = await Vue.prototype.$user.getIdToken()
    return this.httpClient
      .post(`/indicators/reliability/sites/${site.sid}/sectors/${sector.sid}?startDate=${startDate}&siteId=${site.id}`, indicators, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        sendSuccessToast(successMessage)
        return res
      })
      .catch(e => {
        console.error('Set Reliability Error', e)
        sendErrorToast(getErrorMessage)
      })
  }

  async getQualityIndicators({ site, customer, date }) {
    const token = await Vue.prototype.$user.getIdToken()
    return this.httpClient
      .get(`/indicators/quality/sites/${site.sid}/customers/${customer.sid}?date=${date}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => res.data)
      .catch(e => {
        console.error('Get Quality Error', e)
        sendErrorToast(getErrorMessage)
      })
  }

  async setQualityIndicators({ site, customer, date, indicators }) {
    const token = await Vue.prototype.$user.getIdToken()
    return this.httpClient
      .post(`/indicators/quality/sites/${site.sid}/customers/${customer.sid}?date=${date}`, indicators, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        sendSuccessToast(successMessage)
        return res.data
      })
      .catch(e => {
        console.error('Set Quality Error', e)
        sendErrorToast(getErrorMessage)
      })
  }

  async getLeftBehindIndicators({ site, date }) {
    const token = await Vue.prototype.$user.getIdToken()
    return this.httpClient
      .get(`/indicators/raq/sites/${site.sid}?date=${date}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => res.data)
      .catch(e => {
        console.error('Get LeftBehind Error', e)
        sendErrorToast(getErrorMessage)
      })
  }

  async setLeftBehindIndicators({ site, date, indicators }) {
    const token = await Vue.prototype.$user.getIdToken()
    return this.httpClient
      .post(`/indicators/raq/sites/${site.sid}?date=${date}`, indicators, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        sendSuccessToast(successMessage)
        return res.data
      })
      .catch(e => {
        console.error('Set Left-Behind Error', e)
        sendErrorToast(getErrorMessage)
      })
  }
}

export default new IndicatorsService()
